import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  private get eSmart(): boolean {
    return document.documentElement.classList.contains('tema-smart');
  }

  private get eIntero(): boolean {
    const url = window.location.href;
    return url.includes("intero.") || document.documentElement.classList.contains('tema-intero');
  }

  private get ehPdvup(): boolean {
    return window.location.href.includes("pdvup.") || localStorage.getItem('simular-pdvup') === 'true';
  }

  private get defaultTitle(): string {
    if (this.eSmart) return "pdvUP";
    return this.ehPdvup ? "pdvUP" : (this.eIntero ? "Íntero" : "modaUP");
  }

  private get defaultFavicon(): string {
    if (this.eSmart) return "assets/favicons/erp4meSmart/favicon.ico";
    return this.ehPdvup ? "assets/favicons/pdvup/favicon.ico" : (this.eIntero ? "assets/favicons/intero/favicon.ico" : "assets/favicons/modaup/favicon.ico");
  }

  constructor(private title: Title) {}

  setTitle(title: string) {
    const newTitle = title ? `${this.defaultTitle} | ${title}` : this.defaultTitle;
    this.title.setTitle(newTitle);
  }

  setFavicon() {
    let favIcon = document.querySelector("#favicon") as HTMLLinkElement;
    favIcon.href = this.defaultFavicon;
  }
}
